import type { VideoUploadLimits } from '@/types';

const MEGABYTE = 1024 * 1024;
const GIGABYTE = 1024 * MEGABYTE;

const formatUnit = (value: number, unit: string, locale: string) =>
  new Intl.NumberFormat(locale, { style: 'unit', unit, unitDisplay: 'short', maximumFractionDigits: 1 }).format(value);

export const formatVideoLimits = ({ max_bytes, max_duration_in_ms }: VideoUploadLimits, locale = 'en') => {
  const minutes = max_duration_in_ms / 60_000;

  return {
    size:
      max_bytes >= GIGABYTE
        ? formatUnit(max_bytes / GIGABYTE, 'gigabyte', locale)
        : formatUnit(max_bytes / MEGABYTE, 'megabyte', locale),
    duration: minutes >= 60 ? formatUnit(minutes / 60, 'hour', locale) : formatUnit(minutes, 'minute', locale),
  };
};

// Whole minutes and seconds, cut to whole seconds as the duration check compares them,
// so a rejected video always reads longer than the limit.
export const formatVideoLength = (durationInMs: number, locale = 'en') => {
  const seconds = Math.floor(durationInMs / 1000);
  const minutes = formatUnit(Math.floor(seconds / 60), 'minute', locale);
  return seconds % 60 ? `${minutes} ${formatUnit(seconds % 60, 'second', locale)}` : minutes;
};
